export const SET_CAMPAIGN_LOADING = 'SET_CAMPAIGN_LOADING'
export const SET_CAMPAIGN = 'SET_CAMPAIGN'
export const ADD_CAMPAIGN = 'ADD_CAMPAIGN'
export const EDIT_CAMPAIGN = 'EDIT_CAMPAIGN'
export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN'
export const TOGGLE_CAMPAIGN_LOCATIONS = 'TOGGLE_CAMPAIGN_LOCATIONS'
export const FETCH_ASSIGN_LOCATIONS = 'FETCH_ASSIGN_LOCATIONS'
